export default "__VITE_ASSET__f0240eca__"